import { Link } from 'react-router'
import { Button } from '~/components/ui'

type StackTraceProps = {
  error: Error
}

export default function StackTrace({ error }: StackTraceProps) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center">
      <div className="space-y-6 text-center">
        <h1 className="text-9xl font-bold text-neutral-800">Error</h1>
        <p className="text-2xl text-neutral-600">Something went wrong</p>
        <p className="text-neutral-500">{error.message}</p>
        {error.stack && (
          <pre className="mt-4 max-h-96 max-w-screen-lg overflow-auto rounded-lg bg-neutral-800 p-4 text-left text-neutral-100">
            <code>{error.stack}</code>
          </pre>
        )}
        <Button asChild>
          <Link to="/" className="mt-6 inline-block">
            Go Back Home
          </Link>
        </Button>
      </div>
    </div>
  )
}
